export const SEPARATOR = ',';

export const autocompleteValue: [] = [];
export const DEFAULT_RANGE_NUMBER_VALUES: [null, null] = [null, null];
export const DEFAULT_FILTER_LOCALE = 'en';
